import { Grid, Chip, Typography, useMediaQuery } from "@mui/material";
import {
  ArrayField,
  Datagrid,
  DateField,
  NumberField,
  ReferenceField,
  TextField,
  FunctionField,
  useNotify,
  useRecordContext,
} from "react-admin";
import { settings } from "app";
import { getFile } from "server/components/DownloadFile";
import AddPeriodsDialog from "./components/AddPeriodsDialog";
import MarkPeriodPaidDialog from "./components/MarkPeriodPaidDialog";
import GenerateReferralDialog from "./components/GenerateReferralDialog";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { specialistRequests } from "api/specialistApi";
import { SectionTitle } from "features/SectionTitle";

const PeriodsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notify = useNotify();
  const record = useRecordContext();
  const specialistId = record?.id;

  return (
    <>
      <SectionTitle
        title="Периоди"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField source="periods">
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
              sx={settings.style.detailsDatagrid}
            >
              <DateField
                source="startDate"
                label="Начална дата"
                locales="bg-BG"
                sortable={false}
              />
              <DateField
                source="endDate"
                label="Крайна дата"
                locales="bg-BG"
                sortable={false}
              />
              <TextField
                source="durationInDays"
                label="Дни"
                sortable={false}
              />
              <ReferenceField
                source="buildingId"
                reference={specialistRequests.getAdvancedSpecializationsBuildingsSelect(
                  record?.advancedSpecializationId,
                )}
                label="Сграда"
                link={false}
                sortable={false}
              >
                <TextField source="buildingNameBg" />
              </ReferenceField>
              <ReferenceField
                source="professorId"
                label="Преподавател"
                reference={specialistRequests.getProfessorsByAdvancedSpecializationSelect(
                  record?.advancedSpecializationId,
                )}
                sortable={false}
              >
                <TextField source="names" />
              </ReferenceField>

              <NumberField
                source="amount"
                label="Сума"
                options={{ style: "currency", currency: "BGN" }}
                locales="bg-BG"
                sortable={false}
              />
              <FunctionField
                label="Плащане"
                render={period =>
                  period.isPaid ? (
                    <Chip
                      label="Платен"
                      color="success"
                      size="small"
                    />
                  ) : (
                    <Chip
                      label="Неплатен"
                      color="warning"
                      size="small"
                    />
                  )
                }
              />
              <FunctionField
                render={period =>
                  !period.isPaid ? (
                    <SecuredComponent permission={permissions.canManageAdvancedSpecializationSpecialists}>
                      <MarkPeriodPaidDialog
                        id={specialistId}
                        periodId={period.id}
                      />
                    </SecuredComponent>
                  ) : null
                }
              />
              <FunctionField
                label="Направление"
                render={period =>
                  period.referralDocumentId ? (
                    <Typography
                      sx={{
                        textDecoration: "underline",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                      onClick={() => getFile(period.referralDocumentId, notify, "private")}
                    >
                      Изтегли
                    </Typography>
                  ) : (
                    <SecuredComponent permission={permissions.canManageAdvancedSpecializationSpecialists}>
                      <GenerateReferralDialog
                        id={specialistId}
                        periodId={period.id}
                      />
                    </SecuredComponent>
                  )
                }
              />
            </Datagrid>
          </ArrayField>
        </Grid>
        <SecuredComponent permission={permissions.canManageAdvancedSpecializationSpecialists}>
          <FunctionField
            render={rec => (
              <AddPeriodsDialog
                id={rec?.id}
                periods={rec?.periods}
                usedDurationInDays={rec?.usedDurationInDays}
                effectiveDurationCapInDays={rec?.effectiveDurationCapInDays}
                advancedSpecializationId={rec?.advancedSpecializationId}
              />
            )}
          />
        </SecuredComponent>
      </Grid>
    </>
  );
};

export default PeriodsSection;
